import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePlanReviewRequirementMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeletePlanReviewRequirementMutation = { __typename?: 'mutation_root', delete_plan_review_requirements_by_pk?: { __typename?: 'plan_review_requirements', id: any } | null };


export const DeletePlanReviewRequirementDocument = gql`
    mutation deletePlanReviewRequirement($id: uuid!) {
  delete_plan_review_requirements_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePlanReviewRequirementMutationFn = Apollo.MutationFunction<DeletePlanReviewRequirementMutation, DeletePlanReviewRequirementMutationVariables>;

/**
 * __useDeletePlanReviewRequirementMutation__
 *
 * To run a mutation, you first call `useDeletePlanReviewRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanReviewRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanReviewRequirementMutation, { data, loading, error }] = useDeletePlanReviewRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanReviewRequirementMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanReviewRequirementMutation, DeletePlanReviewRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanReviewRequirementMutation, DeletePlanReviewRequirementMutationVariables>(DeletePlanReviewRequirementDocument, options);
      }
export type DeletePlanReviewRequirementMutationHookResult = ReturnType<typeof useDeletePlanReviewRequirementMutation>;
export type DeletePlanReviewRequirementMutationResult = Apollo.MutationResult<DeletePlanReviewRequirementMutation>;
export type DeletePlanReviewRequirementMutationOptions = Apollo.BaseMutationOptions<DeletePlanReviewRequirementMutation, DeletePlanReviewRequirementMutationVariables>;